import React from 'react';
import { Trophy } from 'lucide-react';

export default function SportsTeamCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('sports-team-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-indigo-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Trophy className="w-12 h-12 text-indigo-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Name Your Sports Team?
        </h2>
        <p className="text-xl text-indigo-100 mb-8">
          Join thousands of teams who've found their perfect name with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-indigo-600 text-lg px-8 py-4 rounded-lg hover:bg-indigo-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          Create Your Team Name Now!
        </button>
        <p className="mt-6 text-sm text-indigo-200">
          Perfect for all sports and competition levels
        </p>
      </div>
    </section>
  );
}